import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    pupilas: [],
  },

  getters: {
    getPupilas: (state) => state.pupilas,
  },

  mutations: {
    SET_PUPILAS(state, pupilas) {
      state.pupilas = pupilas;
    },
  },

  actions: {
    async fetchPupilas({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catPupilas')
        .then((response) => {
          commit('SET_PUPILAS', response.data.data);
        });
    },
  },
};
